/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { CostCenterListItemDto } from '../model/cost-center-list-item.dto';

export const CostCenterListItemMapper = entity<CostCenterListItemDto>({});
